import { Typography } from 'antd';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

const ConfirmTeamRoleChangeModal = ({ open, onClose, onConfirm }: Props) => {
    return (
        <ConfirmationModal
            width={540}
            title="Update user role?"
            open={open}
            onClose={onClose}
            onCancel={onClose}
            onConfirm={onConfirm}
            content={
                <Typography.Text>
                    This will unassign all draft manifests and jobs currently assigned to this user. Please confirm you
                    want to continue.
                </Typography.Text>
            }
        />
    );
};

export default ConfirmTeamRoleChangeModal;
